export const h = {
  navMenu: ["STARTSEITE","VORREGISTRIERUNG", "HELDEN", "BESONDERHEITEN"],

}



// WEBPACK FOOTER //
// ./src/i18n/lan/de.js